import React from 'react';
import { styled, useTheme } from '@harver/shared-ui';

import { headerHeightDesktop, headerHeightMobile, layoutMaxWidthDesktop, LayoutZIndex } from '../consts';

type HeaderProps = {
    languagePicker?: React.ReactNode;
    helpButton?: React.ReactNode;
};

const StyledHeader = styled.header`
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: ${headerHeightMobile};
    background: ${({ theme }) => theme.colors.neutral['000']};
    pointer-events: none;
    z-index: ${LayoutZIndex.Header};
    ${({ theme }) => theme.shadow};

    @media (min-width: 768px) {
        height: ${headerHeightDesktop};
    }
`;

const Logo = styled.img`
    display: block;
    height: 100%;
    grid-column-start: 1;
    grid-column-end: 3;
    justify-self: left;
    max-height: ${({ theme }) => theme.sizes.large};

    @media (min-width: 768px) {
        max-height: ${({ theme }) => theme.sizes.xLarge};
    }
`;

const ContentContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
    width: 100%;
    max-width: ${layoutMaxWidthDesktop};
    align-items: center;
    padding: 0 ${({ theme }) => theme.sizes.large};
    margin: 0 auto;

    @media (min-width: 768px) {
        padding: 0 ${({ theme }) => theme.sizes.xLarge};
        justify-content: space-between;
    }
`;

export const Header: React.FC<HeaderProps> = ({ helpButton }) => {
    const theme = useTheme();

    return (
        <StyledHeader data-testid="header">
            <ContentContainer>
                <Logo src={theme.header?.logo} data-testid="logo" alt="Logo" />
                <div
                    style={{
                        visibility: helpButton ? 'visible' : 'hidden',
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'flex-end',
                    }}
                >
                    {helpButton}
                </div>
            </ContentContainer>
        </StyledHeader>
    );
};

export default Header;
